import { AxisKind, ValueType } from '@atlas/types'
import type { PanelAxis } from './types'

export type AxisControlKind = 'select' | 'text' | 'number'

/**
 * Which control an axis renders as. A dimension, or a list-valued attribute,
 * gets the existing combobox; a `text`/`number` attribute gets a plain input.
 * Driven entirely by `kind`/`valueType` — never by axis code.
 */
export function axisControlKind(axis: PanelAxis): AxisControlKind {
	// An axis whose values are real entities rather than `axis_value` rows still
	// picks from a list, whatever its storage type says.
	if (axis.forcePicker) return 'select'
	if (axis.kind === AxisKind.ATTRIBUTE) {
		if (axis.valueType === ValueType.TEXT) return 'text'
		if (axis.valueType === ValueType.NUMBER) return 'number'
	}
	return 'select'
}
